import { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

const ToolBarPortal = ({ children }) => {
  const elRef = useRef(null);
  if (!elRef.current) {
    elRef.current = document.createElement('div');
  }

  useEffect(() => {
    const el = elRef.current;
    Object.assign(el.style, {
      position: 'fixed',
      zIndex: 13,
      pointerEvents: 'auto',
    });
    document.body.appendChild(el);
    return () => {
      document.body.removeChild(el);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ReactDOM.createPortal(children, elRef.current);
};

export default ToolBarPortal;
